export default {
  name: 'RoundButton',
  props: {
    text: {
      type: String,
      required: true
    },
    url: {
      type: String,
      required: true
    },
    color: {
      type: String
    },
    styles: {
      type: Object
    }
  }
};